/** URL id: public UUID when the API sent one, otherwise the legacy integer. */
export function publicRef(record) {
  if (record == null) return record;
  if (typeof record === 'object') {
    return record.public_id || record.id;
  }
  return record;
}
